import React from 'react'
import card1 from '../../assets/card1.jpeg'
import card2 from '../../assets/card2.jpeg'
import card3 from '../../assets/card3.png'
import './Why.css'

export default function Why() {
  return (
    <section className='why-section' id='why'>
        <div className="container">
            <h1 className='why-title'>Why Commito is the Perfect Fit for You</h1>
            <div className='why-cards'>
                <div className="row">
                    <div className="col-md-4 col-12">
                        <div className="why-card">
                            <img className='why-card-image' src={card1} alt="" />
                            <div className="why-card-bottom">
                                <h3 className='why-card-title'>Fits Into Your Lifestyle</h3>
                                <p className='why-card-text'>Follow all your favorite drinks effortlessly and keep your hydration on track with a single tap.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-12">
                        <div className="why-card">
                            <img className='why-card-image' src={card2} alt="" />
                            <div className="why-card-bottom">
                                <h3 className='why-card-title'>Smart Reminders</h3>
                                <p className='why-card-text'>Get reminders tailored to your schedule, so you’ll never forget to stay hydrated when it matters most.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-12">
                        <div className="why-card">
                            <img className='why-card-image' src={card3} alt="" />
                            <div className="why-card-bottom">
                                <h3 className='why-card-title'>One-Stop Solution</h3>
                                <p className='why-card-text'>Seamlessly sync with Apple Health and access all your hydration data in one place for a complete overview</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
